import React from "react";
import { AlertTriangle } from "lucide-react";

/**
 * ErrorMessage - Displays an error message
 * @param {Object} message - The error message object
 * @returns {JSX.Element}
 */
const ErrorMessage = ({ message }) => {
    return (
        <div className="flex justify-center w-full">
            <div className="max-w-[80%] bg-red-50 text-red-800 rounded-2xl px-4 py-3 shadow-sm border border-red-100 flex items-start gap-3">
                <AlertTriangle className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" />
                <div>
                    <p className="text-fluid-base whitespace-pre-wrap break-words">
                        {message.content}
                    </p>
                    <span className="text-[10px] opacity-60 mt-1 block text-red-600">
                        {new Date(message.timestamp).toLocaleTimeString([], {
                            hour: "2-digit",
                            minute: "2-digit",
                        })}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default ErrorMessage;
